import styled from 'styled-components';

export const StepContainer = styled.div`
  min-height: 120px;
`;

export const InstructionText = styled.p`
  margin-bottom: 16px;
  color: #434343;
  font-size: 15px;
`;

export const SummaryBox = styled.div`
  margin-bottom: 20px;
  padding: 16px;
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
`;

export const SummaryText = styled.p`
  margin: 0 0 8px 0;
  font-size: 14px;
  color: #434343;

  &:last-child {
    margin: 0;
  }
`;

export const DisclaimerText = styled.p`
  color: #8c8c8c;
  font-size: 13px;
  font-style: italic;
`;

export const EmptyProductsMessage = styled.p`
  margin: 0;
  padding: 16px;
  color: #595959;
  font-size: 14px;
  text-align: center;
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
`;

export const FooterActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 32px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
`;